import { useAppStore } from '@/store/appStore';
import { resolveWorkflowInstanceId } from '@/utils/agentInstance';

/**
 * Resolves the primary workflow_instance_id for a given agent short name.
 * Reads agentInstances from the global Zustand store.
 */
export function useResolveWorkflowInstanceId(
  agentShortName: string
): string | undefined {
  const agentInstances = useAppStore((state) => state.agentInstances);
  return resolveWorkflowInstanceId(agentInstances, agentShortName);
}
